import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Button, CircularProgress } from '@material-ui/core';
import * as DashboardActions from '../../../actions/dashboardActions';

import * as classes from './CustomerSupportExport.module.css';

const CustomerSupportExport = ({
    activeNavCompany,
    createCustomerSupportReport
}) => {
    const [awaitingReport, setAwaitingReport] = useState(false);
    const createCustomerExportReport = async e => {
        e.preventDefault();

        setAwaitingReport(true);
        await createCustomerSupportReport(activeNavCompany.id, {companyId: activeNavCompany.id});
        setAwaitingReport(false);
    };

    return (
        <div className={classes.Main}>
            <div className={classes.ReportDescription}>This report contains information regarding customers' agents including the agent's name, configuration, serial number and firmware. The report also includes device, equipment, sensor, and rule counts as well as other information.</div>
            <Button 
                className={classes.Button} 
                onClick={createCustomerExportReport}
                disabled={awaitingReport}
            >
                Generate
                {awaitingReport ? 
                    <CircularProgress className={classes.CircularProgress} size={20} />
                    : null }
            </Button>
        </div>
    );
};

const mapStateToProps = state => {
    return ({
        activeNavCompany: state.bob.activeNavCompany
    });
};

const mapDisptachToProps = ({
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDisptachToProps)(CustomerSupportExport));
